import React from "react";
import { SERVER } from "../constants";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true, loginFailure: false };
    case "LOGIN_FAILURE":
      return { ...state, loginFailure: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false, loginFailure: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("user_token"),
    loginFailure: false,
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

// ###########################################################

// Shared fallback password ("futbol"), used when a user has no per-user hash set.
// bcrypt.compareSync also accepts $2y/$2b hashes, so per-user hashes from the
// server compare fine regardless of prefix.
var DEFAULT_HASH = '$2a$10$YaYfa9FtZ2IE1OtS89ZDm.j5zh36YNv1KLTUOApKhVzBuikrVGOQu'

// Look up the user's stored password hash, falling back to the shared default
// when the user has none set or the password API is unreachable.
async function resolveHash(login) {
  try {
    var url = new URL(SERVER + '/passwords')
    url.search = new URLSearchParams({ name: login }).toString()
    var response = await fetch(url)
    if (response.ok) {
      var json = await response.json()
      if (json && json.password_hash) {
        return json.password_hash
      }
    }
  } catch (e) {
    console.debug(e)
  }
  return DEFAULT_HASH
}

async function loginUser(dispatch, login, password, history, setIsLoading, setError) {
  setError(false);
  setIsLoading(true);

  var bcrypt = require('bcryptjs')
  var hash = login ? await resolveHash(login) : null

  if (!!login && bcrypt.compareSync(password, hash)) {
    localStorage.setItem('user_token', (new Date()).toISOString())
    localStorage.setItem('name', login)
    setError(null)
    setIsLoading(false)
    dispatch({ type: 'LOGIN_SUCCESS' })

    // The actual landing league is resolved from the user's selected group
    // once /groups loads (see Layout); '/app/fixtures' redirects there.
    history.push('/app/fixtures')
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setError(true);
    setIsLoading(false);
  }
}

function signOut(dispatch, history) {
  localStorage.removeItem("user_token");
  localStorage.removeItem('name')
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  history.push("/login");
}
